import { alpha, type Theme } from "@mui/material/styles";

/** Colors for read-only / disabled encounter inputs (light + dark). */
export type EncounterDisabledFieldTokens = {
  isDark: boolean;
  /** Primary text on disabled inputs, labels, selects, chip labels. */
  disabledText: string;
  /**
   * Dashed outline for standalone disabled selects / type-aheads
   * (slightly lighter than {@link disabledOutlineMuted}).
   */
  disabledOutline: string;
  /** Dashed outline when nested under encounter cards or dictation inner ring. */
  disabledOutlineMuted: string;
  /** Stronger disabled outline (e.g. dictation outer ring). */
  disabledOutlineStrong: string;
  disabledHelperText: string;
  chipDisabledBg: string;
};

export function getEncounterDisabledFieldTokens(
  theme: Theme,
): EncounterDisabledFieldTokens {
  const isDark = theme.palette.mode === "dark";
  const primary = theme.palette.text.primary;
  const secondary = theme.palette.text.secondary;
  const divider = theme.palette.divider;

  return {
    isDark,
    disabledText: isDark ? primary : alpha(primary, 0.87),
    disabledOutline: isDark ? divider : alpha(primary, 0.35),
    disabledOutlineMuted: isDark ? divider : alpha(primary, 0.38),
    disabledOutlineStrong: isDark ? divider : alpha(primary, 0.55),
    disabledHelperText: isDark
      ? secondary
      : alpha(secondary, 0.85),
    chipDisabledBg: isDark
      ? alpha(theme.palette.common.white, 0.08)
      : "hsl(0, 0%, 95%)",
  };
}
